exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._8f9lk4-xEXuNiQ50Mte7n {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  max-width: 100%;\n  overflow-x: hidden;\n  height: 100%;\n}\n._8f9lk4-xEXuNiQ50Mte7n ._3xhwooFujkevxUH7Uuq5HZ {\n  display: flex;\n  flex: 1;\n  background-color: #fff;\n  padding: 0;\n  overflow: hidden;\n}\n._8f9lk4-xEXuNiQ50Mte7n ._3xhwooFujkevxUH7Uuq5HZ .C-XYMXY16GEhFCwUfk1tM {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow: hidden;\n}\n", ""]);
// Exports
exports.locals = {
	"page": "_8f9lk4-xEXuNiQ50Mte7n",
	"content": "_3xhwooFujkevxUH7Uuq5HZ",
	"pane": "C-XYMXY16GEhFCwUfk1tM"
};